import UserName from '../UserName';
import UserPicture from '../UserPicture';

import * as style from './style.module.css';

const UserCrew = ({ crewRole, crewRoleInfo, link = null, ...user }) => (
  <div className={style.user}>
    <UserPicture {...user} action={link} className={style.avatar} />
    <div className={style.text}>
      <UserName {...user} action={link} />
      <div className={style.role}>
        {crewRole} {crewRoleInfo && <span className={style.info}>({crewRoleInfo})</span>}
      </div>
    </div>
  </div>
);

export default UserCrew;
